export default {
    'pages.layouts.userLayout.title': 'Mundësuar nga Sigal Uniqa Group Austria',
    'pages.login.accountLogin.tab': 'Hyrja në llogari',
    'pages.login.accountLogin.errorMessage': 'Emri/fjalëkalimi i pasaktë',
    'pages.login.failure': 'Hyrja dështoi, ju lutemi provoni përsëri!',
    'pages.login.success': 'Hyrja me sukses!',
    'pages.login.username.placeholder': 'Emri i përdoruesit',
    'pages.login.username.required': 'Ju lutemi vendosni emrin tuaj të përdoruesit!',
    'pages.login.password.placeholder': 'Fjalëkalimi',
    'pages.login.password.required': 'Ju lutemi vendosni fjalëkalimin tuaj!',
    'pages.login.phoneLogin.tab': 'Hyrja në telefon',
    'pages.login.phoneLogin.errorMessage': 'Gabimi i kodit të verifikimit',
    'pages.login.phoneNumber.placeholder': 'Numri i telefonit',
    'pages.login.phoneNumber.required': 'Ju lutemi vendosni numrin tuaj të telefonit!',
    'pages.login.phoneNumber.invalid': 'Numri i telefonit është i pavlefshëm!',
    'pages.login.captcha.placeholder': 'Kodi i Verifikimit',
    'pages.login.captcha.required': 'Ju lutemi vendosni kodin e verifikimit!',
    'pages.login.phoneLogin.getVerificationCode': 'Merr kodin',
    'pages.getCaptchaSecondText': 'sek(et)',
    'pages.login.rememberMe': 'Më kujto',
    'pages.login.forgotPassword': 'Keni harruar fjalëkalimin ?',
    'pages.login.submit': 'Hyrja',
    'pages.login.loginWith': 'Identifikohu me :',
    'pages.login.registerAccount': 'Regjistro llogarinë',
    'pages.welcome.link': 'Mirëserdhe',
    'pages.welcome.alertMessage': 'Janë lëshuar komponentë më të shpejtë dhe më të fortë për punë të rënda.',
    'pages.admin.subPage.title': 'Kjo faqe mund të shikohet vetëm nga Admin',
    'pages.admin.subPage.alertMessage': 'Umi UI është lëshuar tani, mirë se vini të përdorni npm run UI për të filluar përvojën.',
    'pages.searchTable.createForm.newRule': 'Rregulli i ri',
    'pages.searchTable.updateForm.ruleConfig': 'Konfigurimi i rregullave',
    'pages.searchTable.updateForm.basicConfig': 'Informata themelore',
    'pages.searchTable.updateForm.ruleName.nameLabel': 'Emri i rregullit',
    'pages.searchTable.updateForm.ruleName.nameRules': 'Ju lutemi shkruani emrin e rregullit!',
    'pages.searchTable.updateForm.ruleDesc.descLabel': 'Përshkrimi i rregullës',
    'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Ju lutemi vendosni të paktën pesë karaktere',
    'pages.searchTable.updateForm.ruleDesc.descRules': 'Ju lutemi vendosni një përshkrim rregulli me të paktën pesë karaktere!',
    'pages.searchTable.updateForm.ruleProps.title': 'Konfiguro Vetitë',
    'pages.searchTable.updateForm.object': 'Objekt monitorues',
    'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modeli i rregullave',
    'pages.searchTable.updateForm.ruleProps.typeLabel': 'Lloji i rregullit',
    'pages.searchTable.updateForm.schedulingPeriod.title': 'Vendosni periudhën e planifikimit',
    'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Koha e fillimit',
    'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Ju lutemi zgjidhni një orë fillimi!',
    'pages.searchTable.titleDesc': 'Përshkrim',
    'pages.searchTable.ruleName': 'Emri i rregullit kërkohet',
    'pages.searchTable.titleCallNo': 'Numri i thirrjeve të shërbimit',
    'pages.searchTable.titleStatus': 'Statusi',
    'pages.searchTable.nameStatus.default': 'i parazgjedhur',
    'pages.searchTable.nameStatus.running': 'duke vrapuar',
    'pages.searchTable.nameStatus.online': 'online',
    'pages.searchTable.nameStatus.abnormal': 'jonormal',
    'pages.searchTable.titleUpdatedAt': 'Plani i fundit në',
    'pages.searchTable.exception': 'Ju lutemi shkruani arsyen e përjashtimit!',
    'pages.searchTable.titleOption': 'Opsion',
    'pages.searchTable.config': 'Konfigurimi',
    'pages.searchTable.subscribeAlert': 'Abonohuni në sinjalizime',
    'pages.searchTable.title': 'Formulari i kërkesës',
    'pages.searchTable.new': 'I ri',
    'pages.searchTable.chosen': 'i zgjedhur',
    'pages.searchTable.item': 'artikull',
    'pages.searchTable.totalServiceCalls': 'Numri i përgjithshëm i thirrjeve të shërbimit',
    'pages.searchTable.tenThousand': '0000',
    'pages.searchTable.batchDeletion': 'fshirje në bath',
    'pages.searchTable.batchApproval': 'aprovimi i grupit',
    'pages.welcome.toEsig': 'Mirë se erdhe në ESIG! Më poshtë do të gjeni ndihmë se si të përdorni programin për të përfituar sa më shumë prej tij.',
    'pages.welcome.hello': 'Përshëndetje',
    'pages.welcome.renewals': 'Rinovimet',
    'pages.welcome.renewals.policy': 'Polica',
    'pages.welcome.renewals.expiration_date': 'Data e skadencës',
    'pages.welcome.renewals.actions': 'Veprimet',
    'pages.welcome.monthlySales': 'Shitjet mujore',
    'pages.welcome.dailySales': 'Shitjet ditore',
    'pages.welcome.monthlyCommissions': 'Komisionet mujore',
    'pages.welcome.dailyCommissions': 'Komisionet ditore',
    'pages.welcome.productSales': 'Policat e shitura',
    'pages.welcome.portfolio.daily': 'Shitjet ditore',
    'pages.welcome.policies.motor': 'Motor',
    'pages.welcome.policies.pasuria': 'Pasuria',
    'pages.welcome.renewals.actions.renew': 'Rinovo',
    'pages.welcome.target': 'Qëllimi i synuar',
    'pages.welcome.policies': 'Policat',
    'pages.welcome.policies.all': 'Të gjitha',
    'pages.welcome.policies.property': 'Prona',
    'pages.welcome.target.tooltip': 'Synimi',
    'pages.welcome.monthlySales.tooltip': 'Shitjet',
    'pages.welcome.monthlyCommissions.tooltip': 'Komisionet',
    'pages.welcome.productSales.tooltip': 'Shitjet',
    'pages.welcome.title1': 'Shitje & Rinovime',
    'pages.welcome.desc1': 'Mësoni si të përdorni ESIG për të shitur, për të konfiguruar rinovimet, si dhe të menaxhoni policat pas shitjes.',
    'pages.welcome.title2': 'Dëme',
    'pages.welcome.desc2': 'Ju duhet ndihmë për të krijuar, monitoruar, apo menaxhuar praktika dëmesh?',
    'pages.welcome.title3': 'Kontaktoni me suportin',
    'pages.welcome.desc3': 'Nëse asnjë nga artikujt e dokumentimit nuk ju ndihmon, kontaktoni me suportin teknik.',
    'pages.login.login': 'Duhet të identifikoheni!',
    'pages.login.loginButton': 'Hyrja',
    'pages.sales.motor.tpl.search': 'Kërko makinë',
    'pages.sales.motor.tpl.configuration.policy': 'Polica',
    'pages.404.sorry': 'Na vjen keq, faqja që vizituat nuk ekziston.',
    'pages.404.back': 'Kthehu në kryefaqe',
    'pages.403.sorry': 'Na vjen keq, ju nuk keni të drejtë të hyni në këtë faqe.',
    'pages.403.back': 'Kthehu në kryefaqe',
    'pages.default': 'Kjo faqe nuk ka përfunduar akoma!',
    'pages.products.add': 'Shto produktin',
    'pages.products.product': 'Produkt',
    'pages.list.motor': 'Produkte motorike',

    'pages.products.TPL': 'TPL',
    'pages.products.Casco': 'Kasko',
    'pages.products.MiniCasco': 'MiniKasco',
    'pages.products.Green Card': 'Kartoni jeshil',
    'pages.products.Border': 'Kufitarja',
    'pages.products.Passenger': 'Pasagjerët',
    'pages.products.Autosos': 'Autosos',

    'pages.motor.desc': 'TPL mbulon deri në 24,000,000 lekë në rast aksidenti.',
    'pages.motor.gpsDesc': 'Vlera e mjetit ka arritur ose është më e madhe se',
    'pages.motor.gpsDesc1': 'Kjo police do të përfshijë mbulim falas me GPS. Nëse e konfirmoni, Sigal Uniqa Group Austria do të njoftohet me një email automatik.',
    'pages.motor.cs.minicasco.title': 'Minicasco',
    'pages.motor.cs.minicasco.description': 'Sigurimi që ju mbulon në rast të një aksidenti të gabuar.',
    'pages.motor.cs.teleshendet.title': 'TeleShendet',
    'pages.motor.cs.teleshendet.1': 'Familja',
    'pages.motor.cs.teleshendet.2': 'Përdoret nga anëtarët e familjes. Deri në 4 persona.',
    'pages.motor.cs.teleshendet.3': 'Personale',
    'pages.motor.cs.teleshendet.4': 'Përdoret vetëm nga 1 person',

    'pages.map.report': 'Të gjitha policat:',

    'pages.health.private': 'Shëndeti privat',
    'pages.health.travel': 'Shëndeti në udhëtim',
    'pages.health.travel-embassy': 'Shëndet në udhëtim (Ambasadë)',
    'pages.health.antitumor': 'Antitumor',
    'pages.health.life-plus': 'Jete Plus',
    'pages.health.travelPlus': 'Shëndeti në Travel Plus',
    'pages.health.list': 'Produktet e shendetit',

    'pages.branch.Add Branch': 'Shto një degë',
    'pages.list.property': 'Produktet e pronës',
    'pages.property.Add Bank': 'Shto bankë',
    'pages.property.Bank': 'Bank',

    'pages.products.Fire': 'Zjarri',

    'pages.products.Liability': 'Përgjegjësia',

    'pages.products.PublicLiability': 'Përgjegjësia Publike',
    'pages.products.ProductLiability': 'Përgjegjësia e Produktit',
    'pages.products.ProfessionalLiability': 'Përgjegjësia Profesionale',
    'pages.products.EmployerLiability': 'Përgjegjësia e Punëdhënësit',
    'pages.products.PollutionLiability': 'Përgjegjësia e Ndotjes',
    'pages.products.DirectorsAndOfficersLiability': 'Përgjegjësia e Drejtorëve dhe Zyrtarëve',
    'pages.products.BuilderLiability650': 'Përgjegjësia e Ndërtuesit (VKM 650)',
    'pages.products.BuilderLiability693': 'Përgjegjësia e Ndërtuesit (VKM 693)',
    'pages.products.OtherLiability': 'Përgjegjësia të Tjera',
    'pages.products.FuelLiability': 'Përgjegjësia e Karburantit',

    'pages.products.Guaranty': 'Garancia',

    'pages.blockedObjects.title': 'Objektet e Siguruara të Bllokuara',
    'pages.blockedObjects.AddBlockedObject': 'Shto objekt të bllokuar',

    'pages.communicationExclusion.Add': 'Shto përjashtim komunikimi',
    'pages.communicationExclusion.Edit': 'Ndrysho përjashtimin e komunikimit',

    'pages.refresh.title': 'Ne sistem (Esig) eshte kryer nje publikim i ri por ju keni akoma versionin e vjeter!',
    'pages.refresh.button': 'Rifresko sistemin per te marre ndryshimet e reja!',

    'pages.loading.title': 'Nese sistemi vonon shume, ju mund ta rifreskoni!',
    'pages.loading.refresh': 'Rifresko',

    'auth0.Permissions': 'Akseset',
    'auth0.Roles': 'Rolet',

    'pages.auth0.General': 'Gjeneral',
    'pages.auth0.User Card': 'Karta e përdoruesit',
    'pages.auth0.Add User': 'Shto përdorues',
    'pages.auth0.Add Permission': 'Shto akses',
    'pages.auth0.Permission Card': 'Karta e aksesit',
    'pages.auth0.Role Card': 'Karta e rolit',
    'pages.auth0.Add Role': 'Shto rol',

    'pages.accountDetails.bankName': 'Emri i Bankës',
    'pages.accountDetails.bankCode': 'Kodi i Bankës',
    'pages.accountDetails.currency': 'Monedha',
    'pages.accountDetails.accountName': 'Emri i Llogarisë',
    'pages.accountDetails.accountNumber': 'Numri i Llogarisë',
    'pages.accountDetails.accountIban': 'IBAN i Llogarisë',

    'pages.accountDetails.mandateButton': 'Hidh mandatin',
    'pages.accountDetails.editButton': 'Edito mandatin',

    'pages.accountDetails.finalizeMandate': 'Finalizo Mandatin',

    'pages.accountDetails.accountBalance': 'Gjendja e Llogarisë',
    'pages.accountDetails.detailedQueryTitle': 'Kërkesa e Detajuar',
    'pages.accountDetails.selectAccountToAccessStep': 'Zgjidh llogarinë për të aksesuar këtë hap',

    'pages.accountDetails.tableTitle': 'Tabela',
    'pages.accountDetails.searchClientInvoices': 'Kërko fatura klienti',
    'pages.accountDetails.searchAgentInvoices': 'Kërko fatura agjenti',
    'pages.accountDetails.searchPolicyInvoice': 'Kërko fatura police',
    'pages.accountDetails.createBankAccount': 'Krijo llogari bankare',
    'pages.finance.goToBankAccounts': 'Shko tek llogarite bankare',
    'pages.finance.downloadBankAccountsBalances': 'Shkarko balancat e llogarive bankare',
    'pages.finance.downloadCsv': 'Shkarko CSV',
    'pages.finance.downloadXlsx': 'Shkarko Excel',
    'pages.finance.fromDate': 'Nga Data',
    'pages.finance.toDate': 'Deri Ne daten',
    'pages.finance.newMandate': 'Mandat i Ri',
    'pages.finance.AddbankAccount': ' Shto llogari bankare',
    'pages.finance.BankAccount': 'Llogarite Bankare',
    'pages.finance.dailyExchangeRate': 'Kursi Ditor',

    'pages.marine.list': 'Marina',
};
